import { render } from "./order.vue?vue&type=template&id=1a6d852e"
import script from "./order.vue?vue&type=script&lang=js"
export * from "./order.vue?vue&type=script&lang=js"

import "./order.vue?vue&type=style&index=0&id=1a6d852e&lang=css"
script.render = render

export default script